<template>
  <v-container
    fluid
    fill-height
  >
    <v-row>
      <v-col>
        <v-card>
          <v-card-text>
            <v-row class="align-center justify-right">
              <v-spacer />
              <v-col
                cols="3"
                class="text-right"
              >
                <add-new-button
                  title="Add asset"
                  @click="showAddAssetDialog = true"
                />
              </v-col>
            </v-row>
            <url-persisted-data-table
              :v-model="selectedRow"
              :headers="headers"
              :items="items"
              :loading="loading"
              :no-data-text="loadingOrNoDataText"
              default-sort-by="entryDate"
              :default-sort-desc="true"
              :single-select="true"
              :class="{
                'hide-colgroup table-fixed': $vuetify.breakpoint.xs,
                'table-is-mobile': tableIsMobile,
              }"
              @click:row="selectTableRow"
            >
              <template #[`item.entryDate`]="{ item }">
                {{ formatEntryDate(item) }}
              </template>
              <template #[`item.assetType`]="{ item }">
                <asset-type-label :asset-type="item.assetType" />
              </template>
            </url-persisted-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <add-asset-dialog
      :show-dialog="showAddAssetDialog"
      @cancelClick="showAddAssetDialog = false"
    />
  </v-container>
</template>

<script>
import AddNewButton from '@/components/AddNewButton'
import UrlPersistedDataTable from '@/components/UrlPersistedDataTable.vue'
import AddAssetDialog from '@/components/AddAssetDialog'
import AssetTypeLabel from './AssetTypeLabel.vue'

export default {
  name: 'AssetRegister',
  components: {
    AddAssetDialog,
    AssetTypeLabel,
    AddNewButton,
    UrlPersistedDataTable
  },
  data: function () {
    return {
      loading: true,
      tableIsMobile: false,
      showAddAssetDialog: false,
      selectedAsset: {},
      selectedRow: null
    }
  },
  computed: {
    headers() {
      const headers = [
        { text: 'Asset ID', value: 'assetId', hidden: false },
        { text: 'Asset Name', value: 'assetName', hidden: false },
        { text: 'Type', value: 'assetType', hidden: false },
        { text: 'Details', value: 'details', hidden: false },
        { text: 'Entry Date', value: 'entryDate', hidden: false },
        { text: 'Asset Value', value: 'assetValue', hidden: false },
        { text: 'Currency', value: 'currencyType', hidden: false }
      ]

      return headers.filter((header) => !header.hidden)
    },
    items() {
      if (this.loading) {
        return []
      }

      return this.assets
    },
    loadingOrNoDataText() {
      return this.loading ? 'Loading items...' : 'No data.'
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_appUser', 'get_account'])
    this.mapStates(['appUser', 'account', 'assets'])
    this.mapGetters(['isAccountAdmin'])
    this.$store.dispatch('get_assets').then(() => {
      this.loading = false
    })
  },
  methods: {
    async selectTableRow(item, row) {
      this.$router
        .push({ query: this.$route.query, path: `/register/assets/${item.id}` })
        .catch(() => {})
      row.select(true)
    },
    formatEntryDate(item) {
      return item.timestamp.toDate().toLocaleString()
    }
  }
}
</script>

<style lang="scss" scoped></style>
